import React from 'react';

export interface IconEcomArrowDownProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconEcomArrowDown: React.FC<IconEcomArrowDownProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <g clipPath="url(#clip0_7915_1826)"> <path d="M8 1L8 15M8 15L14 9.75M8 15L2 9.75" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" /> </g> <defs> <clipPath id="clip0_7915_1826"> <rect width="16" height="16" fill={fill || "white"} /> </clipPath> </defs>  
    </svg>
  );
};

export default IconEcomArrowDown;
